import { useParams } from "react-router-dom";

interface ErrorInfo {
  code: number;
  message: string;
}
export const Errors: { [index: string]: ErrorInfo } = {
  Default: { code: 0, message: 'Something trouble' },
  UnknwonTenant: { code: 100, message: 'Unknwon tenant' }
}
export const ErrorPage = () => {
  const { code } = useParams()

  const errorCode = code ? parseInt(code) : 0
  const errorKey = Object.keys(Errors).find((key) => Errors[key].code === errorCode)
  const message = errorKey ? Errors[errorKey].message : Errors.Default.message
  
  return (
    <>
      <h1>error!</h1>
      <p>{message}</p>
    </>
  )
}
